module.exports = __webpack_public_path__ + "2f9218ea27dbb44750949f586391980d.pdf";